import { render, staticRenderFns } from "./viewSwitch.vue?vue&type=template&id=c2849626&scoped=true&"
import script from "./viewSwitch.vue?vue&type=script&lang=ts&"
export * from "./viewSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./viewSwitch.vue?vue&type=style&index=0&id=c2849626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2849626",
  null
  
)

export default component.exports